export enum HormonesKeysEnum {
  testosterone = 'testosterone',
  estradiol = 'estradiol',
  testosterone_anastrozole = 'anastrozole',
}
